import React from 'react';

import { getClass } from '../../../utils/component-helpers';

export default ({
  items,
  staticFields,
  identifierField,
  focusIndex,
  searchTerm,
  selectCallback,
  numSelected,
}) => {
  // If searchTerm is passed, pre-filter the items
  if (searchTerm || staticFields) {
    items = items.filter(item => {
      return (
        item.label.toLowerCase().match(searchTerm.toLowerCase()) &&
        !staticFields.includes(item.name)
      );
    });
  }

  function getListDivider(index) {
    return numSelected !== items.length && index === numSelected - 1 ? (
      <hr className="selected-divider" />
    ) : null;
  }

  return (
    <ul className="dropdown-list">
      {items.map((item, i) => {
        let identifier = '';
        if (identifierField) identifier = item[identifierField];
        /*
         * If items are filtered out by staticFields or search term,
         * its current index would differ from its index in the master list of items.
         * item.index is the index at parent state, while i is the current index.
         */
        return (
          <li
            key={i}
            className={getClass(`dropdown-item ${identifier}`, {
              focus: item.index === focusIndex,
              selected: item.selected,
              disabled: item.disabled,
              hidden: item.hidden,
            })}
            onClick={event => selectCallback(item.index, event)}
          >
            <label>
              <span className="checkbox"></span>
              {item.label}
            </label>
            {getListDivider(i)}
          </li>
        );
      })}
    </ul>
  );
};
